﻿'use strict';
var _ = require('lodash');


// @ngInject 
var aboutCtrl = function ($scope, cfg) {

    $scope.cfg = cfg;
    //throw ("test error");
};


module.exports = aboutCtrl;

